import {Customization} from '@eduvision/toolkit';
// import {default as CustomRegisterForm} from '../components/RegisterForm';

export const RegisterForm: Customization['RegisterForm'] = {
  companyIsRequired:true
};